import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { I18nProvider } from "@/lib/i18n";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ChippyChat from "@/components/ChippyChat";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import RequestTraining from "@/pages/RequestTraining";
import AdminDashboard from "@/pages/AdminDashboard";
import TrainerDashboard from "@/pages/TrainerDashboard";
import ParentDashboard from "@/pages/ParentDashboard";

function ProtectedRoute({ role, children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-muted-foreground">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) return <Navigate to={`/${user.role}`} replace />;
  return children;
}

function Shell({ children, hideFooter }) {
  return (
    <div className="min-h-screen flex flex-col bg-background text-foreground">
      <Header />
      <main className="flex-1">{children}</main>
      {!hideFooter && <Footer />}
    </div>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <I18nProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Shell withChippy><Landing /></Shell>} />
              <Route path="/request-training" element={<Shell withChippy><RequestTraining /></Shell>} />
              <Route path="/login" element={<Shell hideFooter><Login /></Shell>} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute role="admin">
                    <Shell hideFooter><AdminDashboard /></Shell>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/trainer"
                element={
                  <ProtectedRoute role="trainer">
                    <Shell hideFooter><TrainerDashboard /></Shell>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/parent"
                element={
                  <ProtectedRoute role="parent">
                    <Shell hideFooter><ParentDashboard /></Shell>
                  </ProtectedRoute>
                }
              />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <Toaster richColors position="top-right" />
          </BrowserRouter>
        </AuthProvider>
      </I18nProvider>
    </ThemeProvider>
  );
}
